import React from 'react';
import { inject, observer } from 'mobx-react';
import BankAccountDisplay from 'js/components/core/BankAccountDisplay';
import Container from './Container';

export default inject('page')(
  observer(({ page }) => (
    <Container>
      <BankAccountDisplay
        bankAccount={page.bankAccount}
        onEdit={page.showBankAccountModal}
        isBusy={page.isBusy}
      />
    </Container>
  )),
);
